import Shipping from "../assets/img/shipping.svg"
import ReturnMoney from "../assets/img/return-money.svg"
import Packaging from "../assets/img/packaging.svg"
import Discount from "../assets/img/discount.svg"
import { useTranslation, Trans } from "react-i18next"

const Features=()=>{
    const { t } = useTranslation();
    return <div className="features section-padding">
        <div className="container">
            <div className="row justify-content-center gy-4">
                <div className="col-6 col-sm-6 col-md-3">
                    <div
                        className="feature text-center d-flex flex-column justify-content-center"
                    >
                        <div className="feature-img">
                            <img src={Shipping} alt=""/>
                        </div>
                        <h6 className="mb-0">{t('Free Delivery')}</h6>
                        <hr className="feature-hr"/>
                        <p className="mb-0">{t('for orders over 20,000 IQD')}</p>
                    </div>
                </div>
                <div className="col-6 col-sm-6 col-md-3">
                    <div
                        className="feature text-center d-flex flex-column justify-content-center"
                    >
                        <div className="feature-img">
                            <img src={ReturnMoney} alt=""/>
                        </div>
                        <h6 className="mb-0">{t('Free Returns')}</h6>
                        <hr className="feature-hr"/>
                        <p className="mb-0">{t('returns are free within 3 days')}</p>
                    </div>
                </div>
                <div className="col-6 col-sm-6 col-md-3">
                    <div
                        className="feature text-center d-flex flex-column justify-content-center"
                    >
                        <div className="feature-img">
                            <img src={Packaging} alt=""/>
                        </div>
                        <h6 className="mb-0">{t('Beautifully Packed')}</h6>
                        <hr className="feature-hr"/>
                        <p className="mb-0">{t('in stylish colorful wrap')}</p>
                    </div>
                </div>
                <div className="col-6 col-sm-6 col-md-3">
                    <div
                        className="feature text-center d-flex flex-column justify-content-center"
                    >
                        <div className="feature-img">
                            <img src={Discount} alt=""/>
                        </div>
                        <h6 className="mb-0">{t('Top Discount')}</h6>
                        <hr className="feature-hr"/>
                        <p className="mb-0">{t('saving your money')}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
export default Features;